import adminAPI from "./adminAPI";
class RolesService {
    listRoles = () => {
        return adminAPI.get(`/roles/captain-console`);
    }
}

export default new RolesService();